const PINNED_KEY = 'couplespace:chat-pinned-ids';
const ARCHIVED_KEY = 'couplespace:chat-archived-ids';

function readIdSet(key: string): Set<string> {
  if (typeof window === 'undefined') {
    return new Set();
  }
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) {
      return new Set();
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) {
      return new Set();
    }
    return new Set(parsed.filter((id): id is string => typeof id === 'string'));
  } catch {
    return new Set();
  }
}

function writeIdSet(key: string, ids: Set<string>): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(key, JSON.stringify([...ids]));
}

export function getPinnedChatIds(): Set<string> {
  return readIdSet(PINNED_KEY);
}

export function isChatPinned(id: string): boolean {
  return getPinnedChatIds().has(id);
}

export function togglePinChat(id: string): boolean {
  const pinned = getPinnedChatIds();
  if (pinned.has(id)) {
    pinned.delete(id);
    writeIdSet(PINNED_KEY, pinned);
    return false;
  }
  pinned.add(id);
  writeIdSet(PINNED_KEY, pinned);
  return true;
}

export function getArchivedChatIds(): Set<string> {
  return readIdSet(ARCHIVED_KEY);
}

export function isChatArchived(id: string): boolean {
  return getArchivedChatIds().has(id);
}

export function archiveChat(id: string): void {
  const archived = getArchivedChatIds();
  archived.add(id);
  writeIdSet(ARCHIVED_KEY, archived);
  const pinned = getPinnedChatIds();
  if (pinned.has(id)) {
    pinned.delete(id);
    writeIdSet(PINNED_KEY, pinned);
  }
}

export function unarchiveChat(id: string): void {
  const archived = getArchivedChatIds();
  archived.delete(id);
  writeIdSet(ARCHIVED_KEY, archived);
}
